import type { GameState, SelectRolesAction } from "../types";

export function applySelectRoles(
  state: GameState,
  action: SelectRolesAction,
): GameState {
  return {
    ...state,
    version: state.version + 1,
    selectedRoleIds: [...action.roleIds],
  };
}
